import React from 'react'
import { Props, StyledStepForm } from './styled'

export const StepForm: React.FC<Props> = (props) => {
  return <StyledStepForm {...props} />
}
